import { render, staticRenderFns } from "./EditUserDetails.vue?vue&type=template&id=aa0c1e16&"
import script from "./EditUserDetails.vue?vue&type=script&lang=js&"
export * from "./EditUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports